
export default {
  APIURL: process.env.VUE_APP_API_ENDPOINT, // 開発
}



// WEBPACK FOOTER //
// ./src/config/config.js